import { useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useTitle } from '../../hooks';
import { Box, Typography, CircularProgress } from '@mui/material';
import FarmContext from '../../store/farm-context';
import colors from '../../assets/colors';

export default function Logout(props) {
  const history = useHistory();
  const farmCTX = useContext(FarmContext);
  useTitle(props.title);
  useEffect(() => {
    localStorage.removeItem('token');
    farmCTX.clearFarmID();
    setTimeout(() => {
      history.push('/login');
    }, 1000);
  });

  return (
    <Box component="div">
      <Typography
        variant="h4"
        component="h1"
        align="center"
        sx={{ color: colors.oldAgroweGreen, mt: '10%' }}
      >
        Wylogowałeś się!
      </Typography>
      <Typography
        variant="h4"
        component="h1"
        align="center"
        sx={{ color: colors.oldAgroweGreen }}
      >
        {' '}
        Przekierowywanie...{' '}
      </Typography>
      <Typography align={'center'}>
        <CircularProgress
          sx={{ color: colors.oldAgroweGreen, mt: '5%' }}
          size={60}
        />
      </Typography>
    </Box>
  );
}
